<!-- ./components/RulesComponent.vue -->
<template>
    <div class="container">
        <h1>Switchcraft Rules</h1>

    <h2>Introduction</h2>
    <p>
    Welcome to Switchcraft, a game where you harness the great energy flowing throughout the veins of the world known as charges. For the very first set of Switchcraft you explore the world of Minslania, inhabited by many things including the ancients of this world. Other sets will take a look at other worlds as well. If you want to learn more about Minslania <a href="#">click here</a>.
    </p>

    <h2>Elements</h2>
    <ul>
    <li><strong>Force:</strong> (Strength, Ferocity, Domination) - high attack fighters and spells that benefit from having them</li>
    <li><strong>Terra:</strong> (Resilience, Survival, Unity) - high health fighters and spells that resist damage and support a strong board</li>
    <li><strong>Light:</strong> (Protection, Energy, Justice) - fighters that provide protection and restore health with spells that punish opponents for their strengths and revive killed allies</li>
    <li><strong>Storm:</strong> (Speed, Evasion, Sweeping) - fighters that attack quickly and control the sky line, spells that draw cards and enforce aggression</li>
    <li><strong>Thermal:</strong> (Damage, Freezing, Amplification) - high damage support with powerful fighter-wiping attack spells</li>
    <li><strong>Abyssal:</strong> (Manipulation, Secrecy, Control) - elusive fighters that lock down and destroy priority targets and spells that offer powerful control</li>
    <li><strong>Noxious:</strong> (Growth, Adaptation, Corrosion) - fighters that grow and adapt and spells that corrode and destroy or evolve your own fighters, occasionally self-destructively</li>
    </ul>

    <h2>ROYGBIV</h2>
    <ul>
    <li><strong>Neutral:</strong> (--)-- (30/5/3)38</li>
    </ul>

    <h2>Starting a Game</h2>
    <p>
    Before the game starts each player shuffles their decks and if an opponent requests it your deck must be cut by an opponent. Then an agreed method of deciding who goes first will be performed. Each player will draw their opening hand of 7 cards and set their life to 30. You are permitted one mulligan, where you will take your 7, set it aside and draw a new 7 then shuffling your old hand back into your deck. Afterwards the turn of the player who was decided to go first starts.
    </p>

    <h2>How to Win &amp; Starting Life</h2>
    <p>
    Each player starts the game with 30 life. A player loses the game when they have 0 or less life. A player loses life whenever they are attacked directly by a fighter (the defending player loses life equal to the attacker's attack) or a card deals damage to that player (also equal to the amount) or says that player loses life. A player also loses if they draw a card with no cards in their deck.
    </p>

    <h2>How to Play Cards</h2>
    <p>
    Any card in your hand may be placed in the charge zone (this does not count as playing that card). Card effects will refer to this placing as being “installed”. You may only install one charge this way per turn and only on either of your Main Steps.
    </p>
    <p>
    While a card is in the charge zone it is referred to as a charge and you may drain it (to drain a card you turn it sideways, on your Turn Start you undrain all your charges) to produce energy which can be used to play cards in your hand.
    </p>
    <p>
    Charges with 1 element produce energy of that element. In order to play a card in your hand you need to use up energy equal to said card's cost. For each element symbol in that card's cost you must drain one energy of that corresponding element, and any generic numbers can be paid by draining any energies equal to the number on the card.
    </p>
    <p>
    Cards with multiple elements, when installed, enter drained and provide one energy of any of their elements when drained.
    </p>

    <h2>Card Types</h2>

    <h3>Entity</h3>
    <p>
    An umbrella term for any card type that stays on the field when played. Fighters, Constructs, Equipment and Zones are all entities. Charges are not entities and bound cards in other zones are not entities.
    </p>

    <h3>Fighter</h3>
    <p>
    Fighters may only be played during your Main Step. When played, Fighters are placed on your side of the field in your choice of front or back line, and have a health and attack stat. When a fighter's health reaches zero they die and are placed in the catacombs. Fighters may attack once per turn and will be drained to signify they cannot attack again.
    </p>

    <h3>Spells</h3>
    <p>
    Spell is a type of card with 2 subtypes - Ritual and Incantation. The subtype of the spell dictates when you can cast it, Rituals can only be cast during your Main Step, while Incantations can be cast during any step of any player's turn as long as you have priority. When you cast a spell its effect will go off once and then will be sent to the catacombs after.
    </p>
    <p>
    If a target for a spell is missing as the spell resolves then the rest of the spell's effects still conclude as best as they can. An example of an effect that can't be concluded is if the spell is asking for a value from the target that was removed, such as a fighter's attack.
    </p>

    <h3>Zones and Constructs</h3>
    <p>
    Zones and Constructs are placed in either the front line or back line when played, though this is only relevant in the case that they become a fighter. Zones and Constructs generally have powerful passive or recurring effects.
    </p>

    <h3>Equipment</h3>
    <p>
    As you play an Equipment, target a fighter you control before the equipment resolves, then place it on the field and bind it to that fighter. Cursed Equipment may target enemy fighters. Equips may only be played during your Main Step.
    </p>
    <p>
    If an equipment enters the field when it is not played then you choose a target to bind to as it enters the field.
    </p>
    <p>
    When a fighter with an equipment attached to it or one that has an equipment being played on it is removed from the field, that equipment is sent to the scrapyard instead of the catacombs. While an equipment is in the scrapyard you may pay its Reclaim cost to return it to your hand.
    </p>
    <p>
    Equipment generally strengthens your fighters.
    </p>

    <h3>Mirror</h3>
    <p>
    Mirror does not show up in type boxes. Rather a mirror is a copy of another spell.
    </p>

    <h2>Combat</h2>
    <p>
    Once you go to the Battle Step of your turn you may choose fighters to attack with. Fighters cannot attack the turn they enter the field. Only fighters in the front line may attack. A fighter may only attack a fighter in the enemy front line and must attack a front line fighter if they are in the front line and count as blocking (see blindness in Keywords). If there are no blocking fighters in the enemy front line then you may choose to attack the opponent directly. When a fighter goes to attack you enter Combat. At the start of each Combat the player whose active turn it is gains priority first before passing it, then if there are no cards or effects being played and both players have passed priority then the math of the combat proceeds. In the case of two fighters, each fighter simultaneously applies damage to the enemy fighter equal to their attack (damage is removed during the End Step).
    </p>

    <h2>Front Line / Back Line</h2>
    <p>
    Each fighter, once per turn, can be moved between lines. Cards in the back line cannot attack but cards in the back line cannot be attacked except by fighters with infiltrator. A fighter cannot change lines the turn it came onto the field or if that fighter didn't have the fighter type at the start of the turn.
    </p>

    <h2>Keyword Abilities</h2>
    <ul>
    <li><strong>Fatal Strike:</strong> Whenever this fighter deals damage to another fighter, destroy that fighter.</li>
    <li><strong>Infiltrator:</strong> Fighters in the enemy's back line are within reach of this fighter. Defenders cannot take the place of fighters this card targets for combat.</li>
    <li><strong>Ranged:</strong> This fighter can attack Aerial fighters, and counts as blocking them.</li>
    <li><strong>Introduction:</strong> This effect activates when the card enters the field.</li>
    <li><strong>Aerial:</strong> Fighters without aerial or climb can't attack this fighter and don't count as blocking it; doesn't count as blocking creatures without aerial.</li>
    <li><strong>Pounce:</strong> This fighter can attack from the back line.</li>
    <li><strong>Untargetable:</strong> This entity can't be the target of any effect an opponent controls.</li>
    <li><strong>Momentum:</strong> While attacking, this fighter strikes first in combat.</li>
    <li><strong>Quickness:</strong> May attack the first turn the fighter is put in play.</li>
    <li><strong>Growth:</strong> Keyword ability that applies a status effect to this card when a condition is met.</li>
    <li><strong>Blindness:</strong> This card does not count as blocking.</li>
    <li><strong>Vengeance:</strong> Whenever this fighter deals damage, gain that much life.</li>
    <li><strong>Surge/Dragonsurge:</strong> Whenever you Surge, your Surge count increases by 1 for the rest of the game. As long as your Surge count is 8 or greater, all of your Dragonsurge abilities activate.</li>
    <li><strong>Strikethrough (X):</strong> Whenever a fighter dies as a result of battle damage dealt by this attacking fighter, this fighter deals X damage to the killed fighter's controller. This damage counts as battle damage.</li>
    <li><strong>Reclaim (X):</strong> While in the catacombs you may pay X to return this card to your hand.</li>
    <li><strong>Armor (X):</strong> Whenever this fighter would be dealt damage, prevent X of that damage.</li>
    <li><strong>Ethereal:</strong> Whenever this card would be put into your catacombs from anywhere, remove it from the game instead.</li>
    <li><strong>Freeze:</strong> Frozen fighters are transformed into an Ice Statue zone with “this zone retains attachments as though it were a fighter” and “at the end of your turn, transform me back into a fighter.” The Ice Statue retains the cost and element of the fighter it is transformed from.</li>
    <li><strong>Melt:</strong> Damage dealt by this source can't be prevented.</li>
    <li><strong>Champion:</strong> The highest-attack fighter among fighters in the front line is the Champion.</li>
    <li><strong>Cursed:</strong> Cursed equipments can be attached to enemy fighters as well as allied ones.</li>
    <li><strong>Sleight:</strong> This card can be played any time you could cast an incantation.</li>
    <li><strong>Skyguard:</strong> This fighter has Aerial, but can be attacked by and counts as blocking fighters without Aerial.</li>
    <li><strong>Power Mark:</strong> A fighter gets +1 attack and health for each power mark on it.</li>
    <li><strong>Decay Mark:</strong> A fighter gets -1 attack and health for each decay mark on it. Decay marks and power marks neutralize each other.</li>
    <li><strong>Stealth:</strong> A fighter with Stealth doesn't count as blocking and can't be attacked.</li>
    </ul>

    <h2>Deck Construction Restrictions</h2>
    <p>
    Every Switchcraft deck must contain 45 cards. You can have up to 3 cards with the same name in your deck at the same time.
    </p>

    </div>
  </template>
  
  <script>
  export default {
    name: "RulesComponent",
  };
  </script>
  
  <style scoped>
  </style>
  